import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

export const CommonCivilStatusCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Stato Civile',
    path: '/stato-civile',
  },
];

export const ResearchNotificationsCivilStatusCrumbs = (idCat: string): Array<BreadcrumbItem> => [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca Registrazioni SC - Anagrafe',
    path: `/stato-civile/notifiche-da-stato-civile/${idCat}`,
  },
];

export const DetailNotificationsCivilStatusCrumbs = (idCat: string): Array<BreadcrumbItem> => [
  ...ResearchNotificationsCivilStatusCrumbs(idCat),
  {
    name: 'Dettaglio Registrazioni SC - Anagrafe',
    path: '/notifiche-da-stato-civile/visualizza/:id/:idNotifica',
  },
];

export const EditNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...ResearchNotificationsCivilStatusCrumbs(idCat),
    {
      name: 'Modifica Registrazioni SC - Anagrafe',
      path: goBackUrl,
    },
  ];
};

export const BirthNotificationsNonResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Registrazione Nascita Non Residenti',
      path: `${goBackUrl}/nascita/non-residenti`,
    },
  ];
};

export const MarriageNotificationsResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/residenti`,
    },
  ];
};

export const MarriageDetailNotificationsResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...MarriageNotificationsResidentCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Registrazione Matrimonio',
      path: `${goBackUrl}/matrimonio/residenti/registrazione`,
    },
  ];
};

export const MarriageNotificationsNonResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/non-residenti`,
    },
  ];
};

export const MarriageDetailNotificationsNonResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...MarriageNotificationsNonResidentCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Registrazione Matrimonio Non Residenti',
      path: `${goBackUrl}/matrimonio/non-residenti/registrazione`,
    },
  ];
};

export const FamilyNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia`,
    },
  ];
};

export const FamilyOtherNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/famiglia/altra`,
    },
  ];
};

export const FamilyMotherNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/famiglia/madre`,
    },
  ];
};

export const FamilyFatherNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/famiglia/padre`,
    },
  ];
};

export const FamilyDetailNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Iscrizione Famiglia',
      path: '/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyOtherDetailNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyOtherNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Iscrizione Famiglia',
      path: '/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/altra/dettaglio',
    },
  ];
};

export const FamilyMotherDetailNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyMotherNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Iscrizione Famiglia',
      path: '/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/altra/dettaglio',
    },
  ];
};

export const FamilyFatherDetailNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyFatherNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Iscrizione Famiglia',
      path: '/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/altra/dettaglio',
    },
  ];
};

export const DeathNotificationsResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/residenti`,
    },
  ];
};

export const DeathCancellationNotificationsResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...DeathNotificationsResidentCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/residenti/cancellazione`,
    },
  ];
};

export const DeathNotificationsNonResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/non-residenti`,
    },
  ];
};

export const DeathCancellationNotificationsNonResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...DeathNotificationsNonResidentCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/non-residenti/cancellazione`,
    },
  ];
};

export const CitizenshipNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/cittadinanza/ricerca`,
    },
  ];
};

export const CitizenshipRegistrationNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...CitizenshipNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Registrazione',
      path: `${goBackUrl}/cittadinanza/ricerca/registrazione`,
    },
  ];
};

export const CohabitationNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Convivenza',
      path: `${goBackUrl}/convivenza`,
    },
  ];
};

export const CohabitationDetailNotificationsCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...CohabitationNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Nascita Convivenza',
      path: `${goBackUrl}/convivenza/nascita`,
    },
  ];
};

export const CivilUnionNotificationsResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/residenti`,
    },
  ];
};

export const CivilUnionDetailNotificationsResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionNotificationsResidentCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Registrazione Unione Civile',
      path: `${goBackUrl}/unione-civile/residenti/registrazione`,
    },
  ];
};

export const CivilUnionNotificationsNonResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/non-residenti`,
    },
  ];
};

export const CivilUnionDetailNotificationsNonResidentCivilStatusCrumbs = (
  goBackUrl: string,
  idCat: string
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionNotificationsNonResidentCivilStatusCrumbs(goBackUrl, idCat),
    {
      name: 'Registrazione Unione Civile Non Residenti',
      path: `${goBackUrl}/unione-civile/non-residenti/registrazione`,
    },
  ];
};

export const CommonSIMACrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'SIMA',
    path: '/stato-civile/SIMA',
  },
];

export const StampCertificateListCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Lista Timbri Certificato',
    path: '/stato-civile/timbri',
  },
];

export const StampCertificateNewCrumbs = [
  ...StampCertificateListCrumbs,
  {
    name: 'Nuovo Timbro Certificato',
    path: '/stato-civile/timbri/nuovo',
  },
];

export const StampCertificateEditCrumbs = [
  ...StampCertificateListCrumbs,
  {
    name: 'Modifica Timbro Certificato',
    path: '/stato-civile/timbri/modifica',
  },
];

export const StampCertificateVisualizeCrumbs = [
  ...StampCertificateListCrumbs,
  {
    name: 'Visualizza Timbro Certificato',
    path: '/stato-civile/timbri/visualizza',
  },
];

export const PrintFormulaListCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Lista Formule stampa',
    path: '/stato-civile/formule',
  },
];

export const PrintFormulaNewCrumbs = [
  ...PrintFormulaListCrumbs,
  {
    name: 'Nuova Formula stampa',
    path: '/stato-civile/formule/nuovo',
  },
];

export const PrintFormulaEditCrumbs = [
  ...PrintFormulaListCrumbs,
  {
    name: 'Modifica Formula stampa',
    path: '/stato-civile/formule/modifica',
  },
];

export const PrintFormulaVisualizeCrumbs = [
  ...PrintFormulaListCrumbs,
  {
    name: 'Visualizza Formula stampa',
    path: '/stato-civile/formule/visualizza',
  },
];

export const DocumentListBirthCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Lista Atti di Nascita',
    path: '/stato-civile/nascita',
  },
];

export const DocumentListCivilUnionCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Lista Atti di Unione Civile',
    path: '/stato-civile/unione-civile',
  },
];

export const DocumentListCitizenshipCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Lista Atti di Cittadinanza',
    path: '/stato-civile/cittadinanza',
  },
];

export const DocumentSearchBirthCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Ricerca Atti di Nascita',
    path: '/stato-civile/nascita/ricerca',
  },
];

export const CertificateCrumbs = [...CommonCivilStatusCrumbs];

export const DocumentSearchCivilUnionCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Ricerca Atti di Unione Civile',
    path: '/stato-civile/unione-civile/ricerca',
  },
];

export const DocumentSearchCitizenshipCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Ricerca Atti di Cittadinanza',
    path: '/stato-civile/cittadinanza/ricerca',
  },
];

export const DocumentCivilStatusCivilUnionCrumbs = [
  ...DocumentListCivilUnionCrumbs,
  {
    name: 'Atto di Unione Civile',
    path: '/stato-civile/unione-civile/carica',
  },
];

export const DocumentCivilStatusCivilUnionUploadCrumbs = [
  ...DocumentListCivilUnionCrumbs,
  {
    name: 'Nuovo Atto di Unione Civile',
    path: '/stato-civile/unione-civile/carica/nuovo',
  },
];

export const DocumentCivilStatusCitizenshipCrumbs = [
  ...DocumentListCitizenshipCrumbs,
  {
    name: 'Atto di Cittadinanza',
    path: '/stato-civile/cittadinanza/carica',
  },
];

export const DocumentCivilStatusCitizenshipUploadCrumbs = [
  ...DocumentListCitizenshipCrumbs,
  {
    name: 'Nuovo Atto di Cittadinanza',
    path: '/stato-civile/cittadinanza/carica/nuovo',
  },
];

export const DocumentCivilStatusCrumbs = [
  ...DocumentListBirthCrumbs,
  {
    name: 'Atto di Nascita',
    path: '/stato-civile/nascita/carica',
  },
];

export const DocumentCivilStatusBirthUploadCrumbs = [
  ...DocumentListBirthCrumbs,
  {
    name: 'Nuovo Atto di Nascita',
    path: '/stato-civile/nascita/carica/nuovo',
  },
];

export const DocumentListDeathCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Lista Atti di Morte',
    path: '/stato-civile/morte',
  },
];

export const DocumentSearchDeathCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Ricerca Atti di Morte',
    path: '/stato-civile/morte/ricerca',
  },
];

export const DocumentCivilStatusDeathCrumbs = [
  ...DocumentListDeathCrumbs,
  {
    name: 'Atto di Morte',
    path: '/stato-civile/morte/carica',
  },
];

export const DocumentCivilStatusDeathUploadCrumbs = [
  ...DocumentListDeathCrumbs,
  {
    name: 'Nuovo Atto di Morte',
    path: '/stato-civile/morte/carica/nuovo',
  },
];

export const DocumentListMarriageCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Lista Atti di Matrimonio',
    path: '/stato-civile/matrimonio',
  },
];

export const DocumentSearchMarriageCrumbs = [
  ...CommonSIMACrumbs,
  {
    name: 'Ricerca Atti di Matrimonio',
    path: '/stato-civile/matrimonio/ricerca',
  },
];

export const DocumentCivilStatusMarriageCrumbs = [
  ...DocumentListMarriageCrumbs,
  {
    name: 'Atto di Matrimonio',
    path: '/stato-civile/matrimonio/carica',
  },
];

export const DocumentCivilStatusMarriageUploadCrumbs = [
  ...DocumentListMarriageCrumbs,
  {
    name: 'Nuovo Atto di Matrimonio',
    path: '/stato-civile/matrimonio/carica/nuovo',
  },
];

export const ActDraftResearchCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca atto da completare',
    path: '/stato-civile/ricerca-atto-da-compilare',
  },
];

export const ActResearchEmergencyCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Recupero Atti Registro di emergenza',
    path: '/stato-civile/recupero-atti-emergenza',
  },
];

export const ActEmergencyEditCrumbs = [
  ...ActResearchEmergencyCrumbs,
  {
    name: 'Modifica',
    path: '/stato-civile/recupero-atti-emergenza/modifica/:idEvento',
  },
];

export const ActResearchCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca Atti',
    path: '/stato-civile/ricerca-atti',
  },
];

export const CommunicationsResearchCrumbs = (
  valueCat?: string,
  idCat?: string
): Array<BreadcrumbItem> => {
  return [
    ...CommonCivilStatusCrumbs,
    {
      name: 'Ricerca Comunicazioni da Atto',
      path: `/stato-civile/ricerca-comunicazioni/${valueCat}/${idCat}`,
    },
  ];
};

export const CommunicationsResearchFromListCrumbs = (
  valueCat?: string,
  idCat?: string
): Array<BreadcrumbItem> => {
  return [
    ...CommonCivilStatusCrumbs,
    {
      name: 'Ricerca Comunicazioni da Lista',
      path: `/stato-civile/ricerca-comunicazioni-da-lista/${valueCat}/${idCat}`,
    },
  ];
};

export const ResearchNotificationsCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca diretta in ANSC',
    path: '/stato-civile/notifiche/ansc/ricerca',
  },
];

export const ResearchNotificationsOperatorCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Gestione notifiche ANSC',
    path: '/stato-civile/notifiche/ansc/ricerca/operatore',
  },
];

export const ResearchNotificationsSideCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Notifiche esclusivamente SIDe',
    path: '/stato-civile/notifiche/side/ricerca',
  },
];

export const ActDomainManagmentSearchCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca Domini',
    path: '/stato-civile/ricerca-dominio',
  },
];

export const ActNewDomainManagement = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca Domini',
    path: '/stato-civile/ricerca-dominio',
  },
  {
    name: 'Inserimento Dominio',
    path: '/stato-civile/ricerca-dominio/nuovo',
  },
];

export const DetailActDomainManagmentCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca Dominio',
    path: '/stato-civile/ricerca-dominio',
  },
  {
    name: 'Visualizza Dominio',
    path: '/stato-civile/ricerca-dominio/dettaglio',
  },
];

export const EditActDomainManagementCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca Dominio',
    path: '/stato-civile/ricerca-dominio',
  },
  {
    name: 'Modifica Dominio',
    path: '/stato-civile/ricerca-dominio/modifica',
  },
];

export const ResearchMunicipalityCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca Comuni',
    path: '/stato-civile/ricerca-comune',
  },
];

export const NewMunicipalityCrumbs = [
  ...ResearchMunicipalityCrumbs,
  {
    name: 'Inserimento Comune',
    path: '/stato-civile/ricerca-comuni/nuovo',
  },
];

export const EditMunicipalityCrumbs = [
  ...ResearchMunicipalityCrumbs,
  {
    name: 'Modifica Comune',
    path: '/stato-civile/ricerca-comuni/modifica',
  },
];

export const DetailMunicipalityCrumbs = [
  ...ResearchMunicipalityCrumbs,
  {
    name: 'Modifica Comune',
    path: '/stato-civile/ricerca-comuni/visualizza',
  },
];

export const ManagementPecCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Gestione PEC',
    path: '/stato-civile/gestione-pec',
  },
];

export const ArchiveAnnotationsPageCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Annotazioni archivio',
    path: '/stato-civile/annotazioni-archivio',
  },
];

export const IcaroResearchCrumbs = (valueCat?: string, idCat?: string): Array<BreadcrumbItem> => {
  return [
    ...CommonCivilStatusCrumbs,
    {
      name: 'Ricerca Icaro',
      path: `/stato-civile/${valueCat}/${idCat}/ricerca-icaro`,
    },
  ];
};

export const RequestMunicipalNumberCrumbs = (
  valueCat?: string,
  idCat?: string
): Array<BreadcrumbItem> => {
  return [
    ...CommonCivilStatusCrumbs,
    {
      name: 'Gestione numerazione comunale - Richiesta',
      path: `/stato-civile/${valueCat}/${idCat}/richiesta-numero`,
    },
  ];
};

export const ResearchMunicipalNumberCrumbs = (
  valueCat?: string,
  idCat?: string
): Array<BreadcrumbItem> => {
  return [
    ...CommonCivilStatusCrumbs,
    {
      name: 'Gestione numerazione comunale',
      path: `/stato-civile/${valueCat}/${idCat}/ricerca-numero`,
    },
  ];
};

export const IcaroDetailCrumbs = (
  valueCat?: string,
  idCat?: string,
  contatore?: string
): Array<BreadcrumbItem> => {
  return [
    ...IcaroResearchCrumbs(valueCat, idCat),
    {
      name: 'Visualizza Icaro',
      path: `/stato-civile/${valueCat}/${idCat}/ricerca-icaro/visualizza/${contatore}`,
    },
  ];
};
